export default __webpack_public_path__ + "static/media/spideyLogo.4eda3ff7.png";